import { createSelector, createSlice } from "@reduxjs/toolkit";
import { userInfoAction } from "../actions";

const initialState = {
  activeUser: {
    data: {
      accessToken: null,
      details: null,
    },
    loading: false,
    error: null,
  },
  logout: {
    loading: false,
    error: null,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuthAction: (state, action) => {
      state.activeUser.data.accessToken = action.payload;
    },
    setAiSearchCount: (state, action) => {
      if (state.activeUser?.data?.details?.remainingSearchCount !== undefined) {
        state.activeUser.data.details.remainingSearchCount = action.payload;
      }
    },
    setUserCompanyAction: (state, action) => {
      if (state.activeUser.data.details) {
        state.activeUser.data.details = {
          ...state.activeUser.data.details,
          selectedCompany: action.payload,
        };
      }
    },
  },

  extraReducers: (builder) => {
    /** CURRENT USER INFO */
    builder.addCase(userInfoAction.pending, (state, action) => {
      state.activeUser.loading = true;
    });
    builder.addCase(userInfoAction.fulfilled, (state, action) => {
      const data = action.payload.data.pilotUserInfo;
      state.activeUser.data.details = data;
      state.activeUser.loading = false;
    });
    builder.addCase(userInfoAction.rejected, (state, action) => {
      state.fetchError = action.error;
      if (action.payload) {
        state.activeUser.errorType = "session_expire";
        state.activeUser.error =
          "Session Expired. Please login again to continue.";
      } else {
        state.activeUser.errorType = "server_error";
        state.activeUser.error =
          "Internal Server Error. Kindly contact your admin.";
      }
      state.activeUser.loading = false;
    });
  },
});

export const { setAuthAction, setAiSearchCount, setUserCompanyAction } =
  authSlice.actions;
export default authSlice;

export const authSelector = createSelector(
  [
    (state) => state.auth.activeUser.data,
    (state) => state.auth.activeUser.loading,
    (state) => state.auth.activeUser.error,
    (state) => state.auth.logout.loading,
    (state) => state.auth.logout.error,
  ],
  (data, loading, error, logoutLoading, logoutError) => ({
    data,
    loading,
    error,
    logoutLoading,
    logoutError,
  })
);
